<div class="search-box">
  <input #searchTextInput [formControl]="searchTextControl" [ngClass]="{'has-value': !!searchTextControl.value}"
    class="input" id="search" autocomplete="off"
    type="text" spellcheck="false">
  <label class="floating" for="search">ISIN, Valor, RIC, Titel, Index...</label>

  <div class="search-box-action">
    @if (searchTerm) {
      <button class="btn btn-clear-search" (click)="clearSearch()" data-test="search-delete-button">Löschen</button>
    }
  </div>
</div>

@if (searchResults$ | async; as searchResults) {
  @if (showSearchResults) {
    @for (option of filterOptions; track option) {
      <button (click)="toggleSelect(option)" class="badge badge-filter" [ngClass]="{selected: option.selected}"
        [disabled]="isDisabled(option.type, searchResults)">{{option.type}}
        <span class="small">(@if (isLoading(option.type, searchResults)){<otcx-loading-indicator-dots>
        </otcx-loading-indicator-dots>} @else {{{getNumberOfResults(option.type, searchResults)}}})</span></button>
  }
  <ul>
    @for (result of searchResults; track result) {
      @if (showResults(result.type)) {
        @for (value of result.values; track value) {
          <li class="search-result-entry" data-test="search-result-entry">
            @if (result.type === searchResultType.SECURITY) {
              <otcx-search-result-security
              [security]="value"></otcx-search-result-security>
            }
            @if (result.type === searchResultType.PUBLICATION) {
              <otcx-search-result-publication
              [searchResultPublication]="value"></otcx-search-result-publication>
            }
            @if (result.type === searchResultType.FAQ) {
              <otcx-search-result-faq
              [faq]="value"></otcx-search-result-faq>
            }
            @if (result.type === searchResultType.MARKET_REPORT) {
              <otcx-search-result-market-report
              [marketReport]="value"></otcx-search-result-market-report>
            }
            @if (result.type === searchResultType.NEWS) {
              <otcx-news-entry [newsEntry]="value"></otcx-news-entry>
            }
          </li>
        }
      }
    }
  </ul>
}
}
